module.exports = __webpack_public_path__ + "img/l_rimg.29a8992b.png";